module.exports = __webpack_public_path__ + "img/ico-reminder.22bca7bd.svg";